import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const userState = (state: AppState) => state.user;

export const userSelector = createSelector(userState, user => user);
